// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"3205bdc3","87":"4ee4fcae","95":"bdb92ad3","193":"d6f187ff","296":"d567bdc7","451":"88bb1e59","587":"c854a74f","630":"5eb31305","710":"9568741f","795":"a1d377ad","797":"58795180"}[chunkId] + ".chunk.js";
};